import {filterDefault} from "@/servicios/app_banners/state";

/**
 * Setea el listado de banners en el state.
 * @param {*} state
 * @param {*} data
 */
export function setList(state, data) {
    state.list = data;
}

/**
 * Setea el banner en el state.
 * @param {*} state
 * @param {*} data
 */
export function setBanner(state, data) {
    const newBanner =  structuredClone(data)
    if (newBanner.is_active == 1) {
        newBanner.is_active = true;
    } else {
        newBanner.is_active = false;
    }
    state.banner = newBanner;
}

/**
 * Setea el showModalForm en el state.
 *
 * @param {*} state
 */
export function setShowModalForm(state, data) {
    state.showModalForm = data;
}

/**
 * Resetea el banner y el defaultBanner en el state.
 * @param {*} state
 */
export function resetBanner(state) {
    (state.banner = {
        id: null,
        title: null,
        is_active: null,
        image: null,
        state: null,
        new_image: null,
    }),
        (state.defaultBanner = {
            id: null,
            title: null,
            is_active: null,
            image: null,
            state: null,
            new_image: null,
        });
}

/**
 * Setear el listado de banners activos en el state.
 *
 * @param {*} state
 * @param {*} data
 */
export function setListActives(state, data) {
    state.listActives = data;
}


/**
 * Filtro por defecto
 * @param {*} state
 * @param {*} quantity
 */
export function clearFilter(state) {
    state.filter = filterDefault();
}


/**
 * Agregar la cantidad de orden disponible.
 * @param {*} state
 * @param {*} quantity
 */
export function setTotalActives(state, quantity) {
    state.totalActives = quantity;
}

/**
 * Agregar último orden de total de banners disponibles
 * @param {*} state
 * @param {*} quantity
 */
export function addOrderBanner(state, last) {
    state.banner.order = last;
}
